module.exports = __webpack_public_path__ + "static/media/ds2.4812fcab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/displayBoard/ds2.svg
// module id = 4482
// module chunks = 0